export const featureFlagsConstants = {
  FEATURE_FLAGS_LOADING: "FEATURE_FLAGS_LOADING",
  FEATURE_FLAGS_SUCCESS: "FEATURE_FLAGS_SUCCESS",
  FEATURE_FLAGS_FAILURE: "FEATURE_FLAGS_FAILURE",
};

export const featureFlagsListConstants = {
  FEATURE_FLAGS_LIST_LOADING: "FEATURE_FLAGS_LIST_LOADING",
  FEATURE_FLAGS_LIST_SUCCESS: "FEATURE_FLAGS_LIST_SUCCESS",
  FEATURE_FLAGS_LIST_FAILURE: "FEATURE_FLAGS_LIST_FAILURE",
};

export const featureAvailableGroupsConstants = {
  FEATURE_AVAILABLE_GROUPS_LOADING: "FEATURE_AVAILABLE_GROUPS_LOADING",
  FEATURE_AVAILABLE_GROUPS_SUCCESS: "FEATURE_AVAILABLE_GROUPS_SUCCESS",
  FEATURE_AVAILABLE_GROUPS_FAILURE: "FEATURE_AVAILABLE_GROUPS_FAILURE",
};

export const featureGlobalActivateConstants = {
  FEATURE_GLOBAL_ACTIVATE_LOADING: "FEATURE_GLOBAL_ACTIVATE_LOADING",
  FEATURE_GLOBAL_ACTIVATE_SUCCESS: "FEATURE_GLOBAL_ACTIVATE_SUCCESS",
  FEATURE_GLOBAL_ACTIVATE_FAILURE: "FEATURE_GLOBAL_ACTIVATE_FAILURE",
};

export const addFeatureTargetGroupsConstants = {
  ADD_FEATURE_TARGET_GROUPS_LOADING: "ADD_FEATURE_TARGET_GROUPS_LOADING",
  ADD_FEATURE_TARGET_GROUPS_SUCCESS: "ADD_FEATURE_TARGET_GROUPS_SUCCESS",
  ADD_FEATURE_TARGET_GROUPS_FAILURE: "ADD_FEATURE_TARGET_GROUPS_FAILURE",
};
